import { useParams } from "react-router-dom";
import { MedicalInfoTab } from "./MedicalInfoTab";

export function MedicalInfoTabRoute() {
  const { tabId } = useParams<{ tabId: string }>();
  return <MedicalInfoTab tabId={tabId ?? "diagnosis"} />;
}
